import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import LaunchFrame from '../LaunchFrame'

class TemporaryLaunchFrame extends Component {
    constructor(props) {
        super(props)

        // Does not affect view and is therefore not stored in state
        this.canRefresh = true

        this.state = { showLaunchFrame: true }
    }

    onTokenExpired = () => {
        // We got a refresh request from the launchFrame
        // If this is the first such request then we can try and refresh
        if (this.canRefresh) {
            this.refreshTokenAndRetry()
        } else {
            // Refresh seems to have failed
            // and we ended up here again
            console.info(
                `Could not auto-refresh token, for ${this.props.userId}. Recommending relogin.`,
            )

            this.props.setClientLaunchProgress(0)

            // Display error message on UI
            this.props.displayAutoRefreshFail()

            // Remove the launch frame
            this.removeLaunchFrame()
        }
    }

    removeLaunchFrame = () => {
        this.setState({ showLaunchFrame: false })
        this.props.unMount()
    }

    refreshTokenAndRetry = () => {
        if (this.props.refreshTokenService !== '') {
            console.info(`Refreshing access token for ${this.props.userId}`)

            this.props.setClientLaunchProgress(60)

            // Sent the refresh token to the launcher token service
            // and retrieve a new access token
            axios({
                method: 'post',
                url: this.props.refreshTokenService,
                data: {
                    token: this.props.refreshToken,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': this.props.locale,
                },
            })
                .then(response => this.updateTokenAndRetry(response.data))
                .catch((error) => {
                    // This message is used through all the errors
                    const commonMessage = `Encountered an error while refreshing token for ${
                        this.props.userId
                    }:`

                    // Reset the client launch progressbar
                    this.props.setClientLaunchProgress(0)

                    if (error.response == null && error.message === 'Network Error') {
                        // No connection could be established to the token service
                        // Log the attempt
                        console.info(
                            `${commonMessage} Token refresh request failed, could not connect to ${
                                this.props.refreshTokenService
                            }`,
                        )

                        // Display generic error message to the user
                        // TODO: Change this to a network related error message
                        this.props.displayRefreshingError()
                    } else if (error.response != null) {
                        // Retrieve status code & text from response
                        const statusText = error.response.statusText
                        const statusCode = error.response.status

                        // Create a log entry with the code & text
                        console.info(
                            `${commonMessage} Token service responded with ${statusCode} ${statusText}`,
                        )

                        // Dictate which type of error message we should display
                        if (error.response.status === 400) {
                            // The SSO responded with Bad Request
                            // This means that the token is likely invalid,
                            // and we should ask the user to relogin
                            this.props.displayAutoRefreshFail()
                        } else {
                            // Display error message on UI
                            this.props.displayRefreshingError()
                        }
                    } else {
                        // Response is null, but not a network error
                        // Log the error message itself
                        console.info(`${commonMessage} ${error.message}`)

                        // An unaccounted for error occurred
                        // Display a generic error message about refresh failing
                        this.props.displayRefreshingError()
                    }

                    // Remove the launcher iframe
                    this.removeLaunchFrame()
                })
        } else {
            console.info('Slinger string was missing when attempting to refresh access token')
            this.removeLaunchFrame()
        }
    }

    updateTokenAndRetry = (tokens) => {
        // console.log(`-------- tokens: ======= '${JSON.stringify(tokens)}' ==== ${tokens}`)
        // console.log(tokens)
        let hash = null
        let accepted = false
        if (tokens.EndUserLicenseAgreement != null) {
            if (tokens.EndUserLicenseAgreement.HasAgreed) {
                accepted = true
            } else {
                hash = tokens.EndUserLicenseAgreement.AgreementHash
            }

            // // Now I need to prompt to show the EULA
            // this.props.showEulaPrompt(
            //     this.props.userId,
            //     tokens.EndUserLicenseAgreement.AgreementHash,
            // )
        }

        // Now I need to prompt to show the EULA
        // ${tokens.EndUserLicenseAgreement.HasAgreed}, ${hash}`)
        this.props.showEulaPrompt(this.props.userId, hash, accepted)

        // Update the user in state
        this.props.setTokens(tokens.AccessToken, tokens.RefreshToken)
        this.props.setClientLaunchProgress(70)

        // Since we have managed to get a new token then we will not
        // allow more refresh retries
        this.canRefresh = false
    }

    render() {
        if (!this.state.showLaunchFrame) {
            return null
        }

        // Create a temporary launch frame to start client
        return (
            <LaunchFrame
                userId={this.props.userId}
                unMount={() => this.removeLaunchFrame()}
                onTokenExpired={refresh => this.onTokenExpired(refresh)}
            />
        )
    }
}

TemporaryLaunchFrame.propTypes = {
    userId: PropTypes.string,
    refreshToken: PropTypes.string,
    refreshTokenService: PropTypes.string,
    unMount: PropTypes.func,
    setTokens: PropTypes.func,
    displayAutoRefreshFail: PropTypes.func,
    displayRefreshingError: PropTypes.func,
    setClientLaunchProgress: PropTypes.func,
    showEulaPrompt: PropTypes.func,
    locale: PropTypes.string,
}

export default TemporaryLaunchFrame



// WEBPACK FOOTER //
// ./src/features/Users/components/UserList/components/TemporaryLaunchFrame/component.js